import React, { useState } from "react";
import { motion } from "motion/react";
import { Button, Typography } from "@mui/material";
import { useMediaQuery } from "react-responsive";

import greenpathlogo from "../../../assets/img/greenpath_logo.png";
import frame1 from "../../../assets/img/Frame1.png";
import frame2 from "../../../assets/img/Frame2.png";

const Greenpath = () => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  const clickSourceCodeBtnHandler = () => {
    window.open("https://github.com/thushaltk/UOK-greenpath-project-20.git");
  };

  return (
    <div
      style={{
        width: "100%",
        height: "600px",
        display: "flex",
        justifyContent: "space-between",
        marginTop: "30px",
        boxShadow: "10px 3px 25px #E0E0E0",
      }}
    >
      {isTabletOrMobile ? (
        ""
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            style={{ width: "35%", height: "100%", textAlign: "left" }}
          >
            <img src={frame1} style={{ width: "70%", height: "100%" }} />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            style={{ width: "35%", height: "100%", textAlign: "right" }}
          >
            <img src={frame2} style={{ width: "70%", height: "100%" }} />
          </motion.div>
        </div>
      )}

      <div
        style={{
          width: "100%",
          height: "600px",
          position: "absolute",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: isTabletOrMobile ? "100%" : "60%",
            height: "100%",
            display: "flex",
            justifyContent: "start",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {isTabletOrMobile ? (
              <motion.img
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                src={greenpathlogo}
                style={{ width: "280px", height: "70%" }}
              />
            ) : (
              <motion.img
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                src={greenpathlogo}
                style={{ width: "33%", height: "70%" }}
              />
            )}
          </div>
          <div style={{ width: "100%", height: "50%" }}>
            {isTabletOrMobile ? (
              <Typography
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                style={{
                  color: "black",
                  textAlign: "center",
                  fontFamily: "tenorite",
                  marginTop: "10px",
                  fontSize: "18px",
                }}
              >
                <motion.span>
                  ARDUINO-BASED CROSS-PLATFORM <br /> MOBILE APP FOR FARMERS{" "}
                  <br /> AND INVESTORS{" "}
                </motion.span>
              </Typography>
            ) : (
              <Typography
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                style={{
                  color: "black",
                  textAlign: "center",
                  fontFamily: "tenorite",
                  marginTop: "10px",
                  fontSize: "20px",
                }}
              >
                <motion.span>
                  ARDUINO-BASED CROSS-PLATFORM MOBILE APP <br /> FOR FARMERS AND
                  INVESTORS{" "}
                </motion.span>
              </Typography>
            )}
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            style={{
              width: "100%",
              height: "60%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Button
              onClick={clickSourceCodeBtnHandler}
              variant="contained"
              style={{
                color: "white",
                borderColor: "green",
                backgroundColor: "green",
              }}
            >
              Source Code
            </Button>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Greenpath;
